import { constant } from 'lodash/fp';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { loadScript } from '@skippay/core/modules/externalScripts';

import { JARABOT } from 'utils/externalScripts';

import { useJarabotFeatureIsEnabled } from './featureFlag';
import { isSupportedRuntime } from './utils';

function JarabotWidgetLoader(): null {
	const dispatch = useDispatch();
	const isEnabled = useJarabotFeatureIsEnabled();

	useEffect(() => {
		if (!isEnabled) return;
		// @ts-expect-error loadScript is redux action
		dispatch(loadScript([JARABOT]));
	}, [isEnabled, dispatch]);

	return null;
}

export default isSupportedRuntime() ? JarabotWidgetLoader : constant(null);
